/*
 * Fetches a catalog type from API and optionally
 * saves it in the vuex store
 * (note: you must first add the catalog type to the
 * vuex catalog module state)
 *
 * Usage: catalogService.fetch('highway')
 *          .then(=> ...)
 *
 * Automatic collection management
 *   catalogService.fetch('highway', {source: this.highways})
 *
 * To receive a particular item:
 *
 * catalogService.fetch('highway', 27)
 *
 * catalogService.fetch('highway', {useStore: true})
 */

import Vue from "vue";

export default (cp) => {
  return Vue.$http
    .get(`catalogs/common/asentamiento/?cp=${cp}`)
    .then(({ data }) => {
      const response = data.data || data;
      let colonies = response.map((item) => {
        return {
          ...item,
          Colonia: item.Colonia || item.colonia,
        };
      });
      return colonies;
    });
};



// WEBPACK FOOTER //
// ./src/services/catalog/fetchColonies.js